module.exports = __webpack_public_path__ + "img/login-mail-verify.6b46072b.svg";